<template>
    <div ref="stage"></div>
</template>

<script>
function lazyLoadTwitter() {
    window.twttr = (function (d, s, id) {
        let js;
        let fjs = d.getElementsByTagName(s)[0];
        let t = window.twttr || {};

        if (d.getElementById(id)) return t;

        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];
        t.ready = function (f) {
            t._e.push(f);
        };

        return t;
    })(document, "script", "twitter-wjs");
}

export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },

    methods: {
        renderTweet() {
            this.$refs.stage.innerHTML = "";

            twttr.ready(() => {
                let id = /^.*?twitter.com\/.*\/status\/([a-z0-9]*).*?$/i.exec(this.url)[1];
                twttr.widgets.createTweet(id, this.$refs.stage, { theme: "dark", dnt: true });
            });
        },
    },

    watch: {
        url() {
            this.renderTweet();
        },
    },

    mounted() {
        lazyLoadTwitter();
        this.renderTweet();
    },
};
</script>
